import { render, staticRenderFns } from "./Gamebay.vue?vue&type=template&id=7de9f345&scoped=true&"
import script from "./Gamebay.vue?vue&type=script&lang=js&"
export * from "./Gamebay.vue?vue&type=script&lang=js&"
import style0 from "./Gamebay.vue?vue&type=style&index=0&id=7de9f345&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de9f345",
  null
  
)

export default component.exports